export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reload.vue?vue&type=template&id=56deceb8&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/reload.vue?vue&type=template&id=56deceb8&
// module id = 1225
// module chunks = 0